import { decodeIdentityToken, decodeToken } from '../../../utils/tokenDecoder';
import IIdentityTokenDecoded from '../../interfaces/IIdentityTokenDecoded';
import ITokenDecoded from '../../interfaces/ITokenDecoded';
import IUser, { userType } from '../../interfaces/IUser';
import IUserCarrier from '../../interfaces/IUserCarrier';

const getUserTypeFromToken = (token: ITokenDecoded): userType => {
    return token.iss.endsWith('Third') ? 'third' : 'ambev';
};

const getRolesFromToken = (token: ITokenDecoded): string[] => {
    return token.resource_access['ambevtech-logco-smartcargas']?.roles;
};

const getUserIdentityFromStorage = (): IIdentityTokenDecoded | null => {
    const identityToken = sessionStorage.getItem('IdentityToken');

    if (identityToken) {
        const decodedIdentityToken = decodeIdentityToken(identityToken);
        return decodedIdentityToken;
    }

    return null;
};

const getUserCarrierFromIdentityToken = (
    identityToken: IIdentityTokenDecoded | null,
): IUserCarrier => {
    const carrier: IUserCarrier = {
        id: identityToken?.carrier_id,
        name: identityToken?.carrier_name,
        sulahub_id: identityToken?.carrier_sulahub_id,
    };

    return carrier;
};

const getUserFromStorage = () => {
    const accessToken = sessionStorage.getItem('AccessToken');
    const userName = localStorage.getItem('DisplayName');

    if (accessToken) {
        const decodedToken = decodeToken(accessToken);

        const userType = getUserTypeFromToken(decodedToken);
        const roles = getRolesFromToken(decodedToken);

        const userIdentity = getUserIdentityFromStorage();

        const userCarrier = getUserCarrierFromIdentityToken(userIdentity);

        const user: IUser = {
            name: userName ?? decodedToken.name,
            email: decodedToken.email,
            roles,
            type: userType,
            country: userIdentity?.country,
            carrier: userCarrier,
        };

        return user;
    }

    return null;
};

export default (() => {
    return {
        getUserFromStorage,
    };
})();
